( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'horizontal-detail-cards', COMPONENT );
} )( app );
